export default {
  exoclick: (state) => state.exoclick,
  trafficstars: (state) => state.trafficstars,
  adnium: (state) => state.adnium,
};
